import { CTA } from '@betterfunnel/types';
import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { uid } from 'uid';
import CreateCTAButtonModal from '../modals/CreateCTAButtonModal';
import IconButton from './Common/IconButton';
import QuillField from './QuillField';
import SortableList from './SortableList';

interface Props {
  title?: string;
  cta?: CTA[];
  onChange?: (cta: CTA[]) => void;
}

export default function CTAListEditor({ title, cta, onChange }: Props) {
  const [selectedCTA, setSelectedCTA] = useState<CTA>();
  const [editModalOpen, setEditModalOpen] = useState(false);

  return (
    <div>
      <CreateCTAButtonModal
        item={selectedCTA}
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setSelectedCTA(undefined);
        }}
        onSave={(button) => {
          const index = cta?.findIndex((b) => b.id === selectedCTA?.id);
          if (cta && index != null && index !== -1) {
            const newArr = [...cta];
            newArr[index] = button;
            onChange?.(newArr);
          } else {
            onChange?.([...(cta || []), button]);
          }

          setEditModalOpen(false);
          setSelectedCTA(undefined);
        }}
      />
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {title || 'Buttons'}
        </label>
        <IconButton
          variant="ternary"
          onClick={() => {
            setSelectedCTA({
              id: uid(8),
              title: 'Button',
              variant:
                cta?.[(cta?.length ?? 0) - 1]?.variant === 'primary'
                  ? 'secondary'
                  : 'primary',
              value: '',
              type: 'link',
            });
            setEditModalOpen(true);
          }}
        >
          <PlusIcon className="h-4 w-4" />
        </IconButton>
      </div>
      <SortableList
        items={cta ?? []}
        renderItemContent={(button) => {
          return (
            <QuillField
              key={JSON.stringify(button.title)}
              value={button.title}
              noDesign
              readOnly
            />
          );
        }}
        renderActions={(button) => {
          return (
            <>
              <IconButton
                variant="primary"
                size="small"
                onClick={() => {
                  setSelectedCTA(button);
                  setEditModalOpen(true);
                }}
              >
                <PencilIcon className="h-4 w-4" />
              </IconButton>
              <IconButton
                variant="primary"
                color="negative"
                size="small"
                onClick={() => {
                  onChange?.(cta?.filter((c) => c.id !== button.id) || []);
                }}
              >
                <TrashIcon className="h-4 w-4" />
              </IconButton>
            </>
          );
        }}
        onChange={(buttons) => {
          onChange?.(buttons);
        }}
      />
    </div>
  );
}
